<div [formGroup]="subscriptionPeriodFormGroup">

    <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
            <mat-label>{{ 'workflows.formWidgets.subscriptionPeriod.paymentInterval' | translate }}</mat-label>
            <mat-select data-test="FS-Zahlungsintervall" formControlName="payableOption"
                        [compareWith]="comparePayableOptions">
                <mat-option *ngFor="let payableOption of payableOptions" [value]="payableOption">
                    {{ payableOption.translationKey | translate }}
                </mat-option>
            </mat-select>
            <mat-error>{{subscriptionPeriodFormGroup.get('payableOption').errors | firstErrorMessage}}</mat-error>
        </mat-form-field>
    </div>

    <br>

    <div fxLayout="column" fxLayoutAlign="start start" class="mb-8">
        <br>
        <strong>
            {{ 'workflows.formWidgets.subscriptionPeriod.recurringPayment' | translate }}
            <ng-container *ngIf="subscriptionPeriodFormGroup.get('payableOption').value?.translationKey as pk">
                            <span style="text-transform: lowercase;">
                                - {{ pk | translate }}
                            </span>
            </ng-container>
        </strong>
    </div>

    <div class="subscription-period-block">
        <h3 [innerHTML]="'workflows.formWidgets.subscriptionPeriod.firstPositionWhenTitle' | translate"></h3>
        <app-input-date-time formControlName="fromDate">
            <label>{{ 'workflows.formWidgets.subscriptionPeriod.firstPositionOn' | translate }}</label>
        </app-input-date-time>
    </div>

    <div class="subscription-period-block">
        <h3 [innerHTML]="'workflows.formWidgets.subscriptionPeriod.lastPositionTitleHtml' | translate"></h3>
        <p class="subscription-period-hint secondary-text">{{ 'workflows.formWidgets.subscriptionPeriod.lastPositionHint' | translate }}</p>
        <app-input-date-time formControlName="toDate">
            <label>{{ 'workflows.formWidgets.subscriptionPeriod.lastPositionOn' | translate }}</label>
        </app-input-date-time>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" class="mb-8">
        <h2>{{ 'workflows.formWidgets.subscriptionPeriod.firstServicePeriodTitle' | translate }}</h2>
        <p>
            {{ 'workflows.formWidgets.subscriptionPeriod.firstServiceIntroPart1' | translate }}
            <ng-container *ngIf="subscriptionPeriodFormGroup.get('payableOption').value?.translationKey; else other">
                <strong style="text-transform: lowercase;">{{ subscriptionPeriodFormGroup.get('payableOption').value?.translationKey | translate }}</strong>
            </ng-container>
            <ng-template #other>{{ 'workflows.formWidgets.subscriptionPeriod.inSelectedInterval' | translate }}</ng-template>
            {{ 'workflows.formWidgets.subscriptionPeriod.firstServiceIntroPart2' | translate }}
        </p>
    </div>

    <ng-container
            *ngIf="subscriptionPeriodFormGroup.get('payableOption')?.value?.id === PayableOptionId.Yearly && seasons?.length">
        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                <mat-label>{{ 'workflows.formWidgets.subscriptionPeriod.pickPeriodicSeasons' | translate }}</mat-label>
                <mat-select data-test="FS-Saisons"
                            [formControl]="seasonFormControl"
                            [compareWith]="compareSeasons">
                    <mat-option [value]="null">{{ 'workflows.formWidgets.subscriptionPeriod.seasonNone' | translate }}</mat-option>
                    <mat-option *ngFor="let season of seasons" [value]="season">
                        {{season.name}} / {{season.startDate | dfnsFormat : 'dd.MM.yyyy'}} -
                        {{season.endDate | dfnsFormat : 'dd.MM.yyyy'}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </ng-container>

    <app-input-date-time formControlName="vestingPeriodFrom">
        <label>{{ 'workflows.formWidgets.subscriptionPeriod.servicePeriodStart' | translate }}</label>
    </app-input-date-time>

    <app-input-date-time formControlName="vestingPeriodUntil">
        <label>{{ 'workflows.formWidgets.subscriptionPeriod.servicePeriodEnd' | translate }}</label>
    </app-input-date-time>

    <ng-container
            *ngIf="[PayableOptionId.Monthly, PayableOptionId.HalfYearly, PayableOptionId.QuarterYearly].includes(subscriptionPeriodFormGroup.get('payableOption')?.value?.id)">
        <div fxLayout="row" fxLayoutAlign="start start">
            <mat-checkbox formControlName="lastDayOfMonth">
                {{ 'workflows.formWidgets.subscriptionPeriod.lastDayOfMonthEnd' | translate }}
            </mat-checkbox>
        </div>
    </ng-container>

</div>
